// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {

    apiKey: "AIzaSyBO8_AEEfd6mDoCctuWmqB5rrtiSTw-bB0",
    authDomain: "peter-kyengo.firebaseapp.com",
    projectId: "peter-kyengo",
    storageBucket: "peter-kyengo.firebasestorage.app",
    messagingSenderId: "827688070961",
    appId: "1:827688070961:web:0447867d9fb6d485f9ca10",
    measurementId: "G-G3H7ZRR19N"
    
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

export { app, storage, db, auth, messaging };